import * as React from "react";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
const Status = ({ statusId }) => /* @__PURE__ */ React.createElement(React.Fragment, null, SECURITY_EVENT_STATUSES[statusId]);
export default Status;
